const availableJobStatuses = [
  {
    value: null,
    label: 'Selecione'
  },
  {
    value: 0,
    label: 'Aguardando aceite'
  },
  {
    value: 1,
    label: 'Aceito'
  },
  {
    value: 2,
    label: 'Recusado'
  }
]

export default availableJobStatuses
